import { useMutation } from '@apollo/client';
import { gql } from '__generated__/gql';
import { FC } from 'react';
import { useNavigate } from 'react-router-dom';

import { FormInput, FormPanel } from 'components/FormPanel';

import { Dialog, DialogPanel, DialogSubTitle, DialogTitle } from 'primitives/Dialog';

import SearchSyndicatesForConversation from './SearchSyndicateForConversation';

type CreateConversationMutationResponse = {
  createConversation: {
    id: string;
  };
};

type CreateConversationMutationVariables = {
  syndicateId: string;
  message: string;
};

const CREATE_CONVERSATION_MUTATION = gql(`
  mutation CreateConversationFromUserToSyndicate($syndicateId: ID!, $message: String!) {
    createConversation(syndicateId: $syndicateId, message: $message) {
      id
    }
  }
`);

const MessageSyndicateDialog: FC<{
  onClose: () => void;
}> = ({ onClose }) => {
  const navigate = useNavigate();

  const [createConversation, { loading, error }] = useMutation<
    CreateConversationMutationResponse,
    CreateConversationMutationVariables
  >(CREATE_CONVERSATION_MUTATION, {
    refetchQueries: ['InvestorConversationsQuery', 'Conversation'],
  });

  return (
    <>
      <Dialog open={true} onClose={onClose}>
        <DialogPanel>
          <DialogTitle>Message Syndicate</DialogTitle>
          <DialogSubTitle>
            This will create a private conversation between you and the syndicate.
          </DialogSubTitle>
          <FormPanel
            loading={loading}
            error={error}
            onSubmit={data =>
              createConversation({
                variables: {
                  syndicateId: data.syndicate.id,
                  message: data.message,
                },
              }).then(response => {
                navigate(`/invest/conversations/${response.data?.createConversation.id}`);
                onClose();
              })
            }
            onCancel={onClose}
          >
            <FormInput
              type="custom"
              fieldName="syndicate"
              label="Name"
              defaultValue={''}
              customInput={SearchSyndicatesForConversation}
              validators={{
                required: true,
              }}
            />
            <FormInput
              fullWidth
              type="textarea"
              label="Message"
              fieldName="message"
              defaultValue=""
            />
          </FormPanel>
        </DialogPanel>
      </Dialog>
    </>
  );
};

export default MessageSyndicateDialog;
